import { useFlags } from "features/api/flags"

export function useIsInitialDepositIntentEnabled(): boolean {
  const { INITIAL_DEPOSIT_INTENT } = useFlags()
  return INITIAL_DEPOSIT_INTENT.boolVal
}
